import { render } from "./Chart.vue?vue&type=template&id=4ef7f99d&scoped=true"
import script from "./Chart.js?vue&type=script&lang=js"
export * from "./Chart.js?vue&type=script&lang=js"

import "./Chart.scss?vue&type=style&index=0&id=4ef7f99d&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef7f99d"]])

export default __exports__